import React from 'react'
import { Label } from '~/lib/ui/label'
import { Checkbox } from '~/lib/ui/checkbox'

const PrivacySettings = ({ setPrivacySettings, privacySettings }) => {
  return (
    <div className="pb-4">
      <Label htmlFor="privacySettings" className="text-base !font-normal">
        Privacy Settings:
      </Label>
      <div className="mt-2 flex flex-row gap-12">
        <label className="flex items-center !font-normal">
          <Checkbox
            className="mr-2"
            checked={privacySettings.includes('all')}
            onCheckedChange={(checked) => {
              if (checked) {
                setPrivacySettings(['all', 'admin', 'csm', 'coach'])
              } else {
                setPrivacySettings([])
              }
            }}
          />
          All
        </label>
        <label className="flex items-center !font-normal">
          <Checkbox
            className="mr-2"
            checked={privacySettings.includes('admin')}
            onCheckedChange={(checked) => {
              setPrivacySettings((prev) => {
                let next = checked
                  ? [
                      ...prev.filter((v) => v !== 'all' && v !== 'admin'),
                      'admin',
                    ]
                  : prev.filter((v) => v !== 'admin')
                if (
                  next.includes('admin') &&
                  next.includes('csm') &&
                  next.includes('coach')
                ) {
                  next = ['all', 'admin', 'csm', 'coach']
                } else {
                  next = next.filter((v) => v !== 'all')
                }
                return next
              })
            }}
          />
          YNS Admins
        </label>
        <label className="flex items-center !font-normal">
          <Checkbox
            className="mr-2"
            checked={privacySettings.includes('csm')}
            onCheckedChange={(checked) => {
              setPrivacySettings((prev) => {
                let next = checked
                  ? [...prev.filter((v) => v !== 'all' && v !== 'csm'), 'csm']
                  : prev.filter((v) => v !== 'csm')
                if (
                  next.includes('admin') &&
                  next.includes('csm') &&
                  next.includes('coach')
                ) {
                  next = ['all', 'admin', 'csm', 'coach']
                } else {
                  next = next.filter((v) => v !== 'all')
                }
                return next
              })
            }}
          />
          CSM Team
        </label>
        <label className="flex items-center !font-normal">
          <Checkbox
            className="mr-2"
            checked={privacySettings.includes('coach')}
            onCheckedChange={(checked) => {
              setPrivacySettings((prev) => {
                let next = checked
                  ? [
                      ...prev.filter((v) => v !== 'all' && v !== 'coach'),
                      'coach',
                    ]
                  : prev.filter((v) => v !== 'coach')
                if (
                  next.includes('admin') &&
                  next.includes('csm') &&
                  next.includes('coach')
                ) {
                  next = ['all', 'admin', 'csm', 'coach']
                } else {
                  next = next.filter((v) => v !== 'all')
                }
                return next
              })
            }}
          />
          Coaching Team
        </label>
      </div>
    </div>
  )
}
export default PrivacySettings
